<script>
  import {onMount, afterUpdate} from 'svelte'
  import gsap from 'gsap'
  import {media} from 'svelte-match-media'
  import ScrollTrigger from 'gsap/ScrollTrigger'

  const availableColors = ['gray', 'white', 'red']

  export let color = availableColors[0]
  export let style = 'left'
  export let start = 'top 70%'
  export let size = 1
  export let desktopSize = size
  export let delay = 0
  export let toggleActions = 'play play play pause'
  
  let self
  
  $: className = 'hline' + ($$props.class ? ' ' + $$props.class : '')
  $: renderedColor = availableColors.indexOf(color) > -1 ? color : availableColors[0]
  $: lineHeight = desktopSize !== size && $media.desktop ? desktopSize : size

  onMount(() => {
    const from = {scaleX: 0, opacity: 0}
    const to = {scaleX: 1, opacity: 1, duration: 0.5, ease: 'power2.out',
      scrollTrigger: {
        trigger: self,
        start,
        toggleActions
      },
      delay
    }
    if(style == 'left') from.transformOrigin = 'left top'
    gsap.fromTo(self, from, to)
  })

</script>
<div bind:this={self} class={className} style="height: {lineHeight}px;" class:white={renderedColor === 'white'} class:red={renderedColor === 'red'} class:gray={renderedColor === 'gray'}></div>

<style>
  .white {
    background: white
  }
  .gray {
    background: var(--gray-line)
  }
  .red {
    background: var(--verizon-red)
  }
</style>